// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__2bKdl","content":"Consent_content__1zlCk","footer":"Consent_footer__1IwtD"};